import React, { useState } from "react";
import { Dropdown, Modal, Table } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import { message } from "antd";
// import axios from "axios";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { getUsers } from "../../lib/user";
import { sendInvitation } from "../../lib/sendEmail";

import Header from "../header/Header";
import SideBar from "../sidebar/SideBar";
import UserHeader from "./UserHeader";
import { db } from "../../config/firebase";
// import { deleteDoc, doc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import EditModal from "react-modal";
import EditUserForm from "./editUserForm";
import { api } from "../../config/api";
import { doc, getDoc } from "@firebase/firestore";
import Loader from "../shared/loader/loader";
import DashboardLayout from "../layout";
import { useMyContext } from "../../context/MyContext";
import TempPasswordModal from "./TempPasswordModal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.79)",
    zIndex: 100,
  },
};

const obj = {
  active: true,
  content: "Clients",
};

const User = () => {
  const queryClient = useQueryClient();
  const [delModal, setDelModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectId, setSelectId] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [user, SetUser] = useState();
  const { user: loggedInUser } = useMyContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tempPasswordModal, setTempPasswordModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const { data, isLoading, isError, refetch } = useQuery(
    ["users", "role", "user"], // Change the key to match the getUsers function
    async () => {
      const res = await getUsers();
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  // console.log(data)
  const deleteMutation = useMutation(
    async (id) => {
      if (!id) return;
      try {
        await api.delete(`/users/${id}`);
      } catch (error) {
        console.error("Error deleting user", error);
        if (error.response && error.response.status === 404) {
          toast.warning("User not found");
        } else {
          toast.error(`Could not delete user: ${error.message}`);
        }
        throw error; // re-throw the error to trigger the onError callback
      }
    },
    {
      onSuccess: () => {
        toast.success("User deleted successfully!");
        queryClient.invalidateQueries(["users"]);
        setDelModal(false);
      },
      onError: (error) => {
        console.error("Delete mutation error:", error);
      }
    }
  );

  const SendMail = async (id) => {
    if (!id) return;
    const toastId = toast.loading("Sending invitation...");
    try {
      const res = await sendInvitation(id);
      toast.update(toastId, {
        render: res?.message || "Invitation sent successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error sending invitation:", error);
      const msg = error?.response?.data?.message || error?.message || "Failed to send invitation";
      toast.update(toastId, {
        render: msg,
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    }
  };

  const handleEdit = (id) => {
    setSelectId(id);
    // console.log(selectId);
    setEditModal(true); // Corrected the position of the log
  };

  const columns = [
    {
      title: "No.",
      render: (_, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "name",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "Postal Code",
      dataIndex: "postalCode",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: "Edit",
                onClick: () => {
                  handleEdit(record?.id);
                },
                visible:
                  loggedInUser?.role === "super admin" ||
                    loggedInUser?.role === "admin" ||
                    loggedInUser?.role === "managing admin"
                    ? true
                    : false,
              },
              {
                key: "2",
                label: "Delete",
                onClick: () => {
                  setDelModal(true);
                  Modal.confirm({
                    title: "Confirm",
                    icon: <ExclamationCircleOutlined />,
                    content: "Are you sure you want to delete this client?",
                    okText: "Delete",
                    cancelText: "Cancel",
                    okType: "danger",
                    onOk: () => {
                      deleteMutation.mutate(record?.id);
                    },
                    open: delModal,
                  });
                },
                visible: true,
              },
              {
                key: "3",
                label: "Temp Password",
                onClick: () => {
                  setSelectedUserId(record?.id);
                  setTempPasswordModal(true);
                },
                visible: loggedInUser?.role === "super admin" ||
                  loggedInUser?.role === "admin" ||
                  loggedInUser?.role === "managing admin",
              },
            ].filter((e) => e.visible),
          }}
          placement="bottomRight"
        >
          <div className="border-2 w-fit rounded-md p-1">
            <BiDotsVerticalRounded className="cursor-pointer" size={20} />
          </div>
        </Dropdown>
      ),
    },
  ];

  // if (isLoading) {
  //   return <div><Loader /></div>;
  // }

  // if (isError) {
  //   return <div>Error loading data</div>;
  // }

  return (
    <>
      <DashboardLayout>
        {/* <div className="h-full sm:block hidden border-r">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full">
          <Header title="Users" />

          <div className="p-5 bg-[#eaeff6]">
            <UserHeader
              filteredData={filteredData}
              setFilteredData={setFilteredData}
              Data={data}
            />
          </div>
          <div className="p-5">
            {isLoading ? (
              <Loader />
            ) : (
              <Table
                columns={columns}
                dataSource={filteredData}
                size="small"
                className="table w-full border-0"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  // total: filteredData.length,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                  },
                }}
              />
            )}
          </div>
        </div>
        <EditModal
          isOpen={editModal}
          onRequestClose={() => setEditModal(false)}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <EditUserForm setOpenModel={setEditModal} id={selectId} />
        </EditModal>
        <TempPasswordModal
          isOpen={tempPasswordModal}
          onClose={() => {
            setTempPasswordModal(false);
            setSelectedUserId(null);
          }}
          userId={selectedUserId}
        />
      </DashboardLayout>
    </>
  );
};

export default User;
